import { useState } from 'react';
import { cn } from '@/lib/utils';
import { APP_STORE_URL, GOOGLE_PLAY_URL, detectPlatform } from '@/utils/appLinks';
import { trackEvent } from '@/lib/analytics';

function AppleLogo({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M16.37 12.6c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.7-3.19-1.73-1.36-.14-2.65.8-3.34.8-.69 0-1.75-.78-2.88-.76-1.48.02-2.85.86-3.61 2.19-1.54 2.67-.39 6.62 1.1 8.79.73 1.06 1.6 2.25 2.74 2.2 1.1-.04 1.52-.71 2.85-.71 1.33 0 1.7.71 2.87.69 1.18-.02 1.93-1.08 2.65-2.14.84-1.23 1.18-2.42 1.2-2.48-.03-.01-2.3-.88-2.32-3.5zM14.2 6.13c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.68-.92 2.67.97.08 1.96-.49 2.56-1.22z" />
    </svg>
  );
}

function PlayLogo({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M5 3.2v17.6c0 .6.65.97 1.17.66l14.3-8.8a.77.77 0 0 0 0-1.32L6.17 2.54A.77.77 0 0 0 5 3.2z" />
    </svg>
  );
}

const storeButtonClass =
  'inline-flex items-center justify-center gap-2 rounded-full px-4 py-3 text-sm font-semibold transition-colors';

// platform = aparelho de quem clicou (ios/android/desktop); store = loja do
// botão — no desktop aparecem as duas, então os dois valores podem diferir.
export function StoreButton({ store, platform, className }) {
  const isApple = store === 'ios';
  return (
    <a
      href={isApple ? APP_STORE_URL : GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent('click_download_app', {
        platform,
        store: isApple ? 'app_store' : 'google_play',
        placement: 'event_card',
      })}
      className={cn(storeButtonClass, 'bg-orange-500 hover:bg-orange-600 text-white', className)}
    >
      {isApple ? <AppleLogo className="w-4 h-4" /> : <PlayLogo className="w-4 h-4" />}
      {isApple ? 'App Store' : 'Google Play'}
    </a>
  );
}

// Convite pra baixar o app. Mostra só a loja do aparelho (iOS/Android) ou
// as duas no desktop.
export function DownloadAppCard({ className }) {
  const [platform] = useState(detectPlatform);
  const stores = platform === 'desktop' ? ['ios', 'android'] : [platform];

  return (
    <div
      className={cn(
        'rounded-2xl border border-orange-500/20 bg-orange-500/5 shadow-sm p-5',
        className
      )}
      data-testid="download-app-card"
    >
      <h3 className="text-base font-bold mb-1.5">Tem muito mais evento no app 🎉</h3>
      <p className="text-sm text-muted-foreground leading-relaxed mb-4">
        Baixe o Joyn grátis e descubra tudo que rola em Joinville: favorite eventos,
        marque 'Eu vou' e receba lembretes.
      </p>
      <div className={cn('grid gap-2', stores.length > 1 && 'grid-cols-2')}>
        {stores.map((store) => (
          <StoreButton key={store} store={store} platform={platform} className="w-full" />
        ))}
      </div>
    </div>
  );
}
